<template>
  <div class="w-100 h-100">
    <div class="w-100 h-100 d-flex align-items-center justify-content-center" v-if="is_load">
      <loader />
    </div>
    <template v-else>
      <CartWideLayout v-if="page_design_type === 'WIDE_VIEW'" ref="layout" />
      <CartMobileLayout v-else ref="layout" />
    </template>

    <b-modal
      size="lg"
      hide-header
      hide-footer
      body-class="p-0"
      centered
      v-model="stripe_modal"
      no-close-on-backdrop
      no-close-on-esc
    >
      <div id="stripe-checkout"></div>
    </b-modal>
  </div>
</template>

<script>
  import {
    mapGetters,
    mapMutations
  } from 'vuex';
  import {
    get,
    post
  } from '@/services/index.js'
  import CartMobileLayout from './layouts/CartMobileLayout.vue';
  import CartWideLayout from './layouts/CartWideLayout.vue';
  import config from '@/config/index.js';
  import { applyResolvedTitle } from '../../../../utils/titleService';
  import { trackPageViewAfterDataLoaded } from '../../../../utils/analytics';

  export default {
    components:{
      CartMobileLayout,
      CartWideLayout
    },
    provide() {
      return {
        cartContext: this,
        posContext: this
      };
    },
    data() {
      return {
        is_load: true,
        error: '',
        general_data: {},
        payment_mode: {
          list: [{
              id: 'PAY_IMMEDIATELY',
              title: 'Instant Payment',
              description: 'Securely pay now for swift confirmation.'
            },
            {
              id: 'PAY_LATER',
              title: 'Pay Later',
              description: 'Enjoy your meal now, settle the bill later.'
            }
          ],
          data: {}
        },
        payment_method: {
          list: [],
          data: {}
        },
        error_push: '',
        validate_payment:{
          mode: false,
          method: false
        },
        tx_inquiry: {},
        tx_payment: {},
        payment_in_page: false,
        reservation:{},
        serve_option:{
          list: [
            {id: 'dine_in',title: 'Dine In',subtitle: 'Savor the moment at our place.'},
            {id: 'delivery',title: 'Delivery',subtitle: 'Effortless dining, delivered to your door.'}
          ],
          selected: {},
          error: ''
        },
        product_detail_popup: {
          show: false,
          pos_id: '',
          product_id: ''
        },
        stripe_modal: false
      }
    },
    computed:{
      ...mapGetters([
        'getMerchant',
        'getOutletTrxCustomerDetail',
        'getOutletTrxProducts',
        'getOutletTrxSubTotal',
        'getOutletTrxPromotion',
        'getOutletTrxTaxService',
        'getOutletTrxTotal',
        'isReservationActive',
        'getReservationActive',
        'isMembershipRewardApplied',
        'getUpsellRef',
        'getOutletTrxPromoCode',
        'getOutletTrxTableNumber',
        'getOutletTrxDelivery',
        'getOutletTrxNotes',
        'getMetaTitleTemplate',
        'getConciergeHomeAuth',
        'getConciergeReservation'
      ]),
      isUsingConciergeAuth() {
        return !!this.getConciergeHomeAuth.reservation_id
      },
      pos_code() {
        return this.$route.params.pos_code
      },
      page_design_type() {
        const page_design = this.general_data.page_design ? this.general_data.page_design : 'MOBILE_VIEW';
        return (page_design === 'WIDE_VIEW' && !this.$is_mobile_view) ? 'WIDE_VIEW' : 'MOBILE_VIEW'
      },
      total_product_cart(){
        return this.getOutletTrxProducts.length
      },
      need_payment(){
        let general_loaded = this.general_data.id
        let default_payment_now = this.general_data.payment_mode == 'PAY_IMMEDIATELY'
        let selected_paymnet_now = this.general_data.payment_mode == 'PAY_IMMEDIATELY_OR_LATER' && this.payment_mode.data.id == 'PAY_IMMEDIATELY'

        return general_loaded && (default_payment_now || selected_paymnet_now)
      },
      payment_surcharge(){
				let total = 0

				if(this.payment_method.data.id){
					if(this.payment_method.data.surcharge_type == 'PERCENT'){
						total = (this.getOutletTrxTotal/100)*this.payment_method.data.surcharge_value
					}else{
						total = this.payment_method.data.surcharge_value
					}
				}

				return total
			},
      delivery_fee(){
        let total = 0
        if(this.general_data.use_delivery && this.serve_option.selected.id == 'delivery' && this.getOutletTrxDelivery.inquiry.delivery_fee){
          total = this.getOutletTrxDelivery.inquiry.delivery_fee
        }
        return total
      },
      total_price(){
        return this.getOutletTrxTotal+this.payment_surcharge+this.delivery_fee
      },
      need_guest_data_for_payment(){
				let return_data = false
        let is_default_pm_immediately = this.general_data.payment_mode == 'PAY_IMMEDIATELY'
        let is_pm_selected_immediately = this.general_data.payment_mode == 'PAY_IMMEDIATELY_OR_LATER' && this.payment_mode.data.id == 'PAY_IMMEDIATELY'
        let is_payment_method_selected = this.payment_method.data.id

				if((is_default_pm_immediately || is_pm_selected_immediately) && is_payment_method_selected){
          return_data = true
				}

				return return_data
			},
      paymentOptionText(){
        const { cart_payment_title: title, cart_payment_subtitle: subtitle } = this.general_data;

        if (title && subtitle) return { title, subtitle };

        const { id: mode = 'PAY_LATER' } = this.payment_mode.data;
        const textDefaults = {
          PAY_IMMEDIATELY: {
            title: 'Payment Method',
            subtitle: 'Choose your preferred way to pay securely.'
          },
          PAY_LATER: {
            title: 'Payment',
            subtitle: 'Enjoy your meal now, settle the bill later.'
          },
          DEFAULT: {
            title: 'Payment Options',
            subtitle: "Choose how you'd like to settle."
          }
        };
        const config = textDefaults[mode] || textDefaults.DEFAULT;
        return {
          title: title || config.title,
          subtitle: subtitle || config.subtitle
        };
      }
    },
    watch:{
      total_product_cart(){
        if(this.total_product_cart == 0){
          setTimeout(() => {
            this.goToPage('PosHome')
          }, 1000);
        }
      }
    },
    mounted(){
      if(this.total_product_cart > 0){
        setTimeout(() => {
          this.$smoothScroll('top-section')
        }, 100);
        this.loadFirstData()
      }else{
        this.goToPage('PosHome')
      }
    },
    methods:{
      ...mapMutations(['setTrxOutletCustomerDetail','clearTrxOutletProduct','setTrxOutletDelivery','setTrxOutletDeliveryType','resetTrxOutletDelivery']),
      loadFirstData() {
        this.is_load = true
        let func_exe = [this.loadGeneralData()]
        if(this.isReservationActive){
          func_exe.push(this.loadDetailReservation())
        }
        Promise.all(func_exe).finally(() => {
          if(this.general_data.use_delivery){
            this.serve_option.selected = this.getOutletTrxDelivery.use ? this.serve_option.list[1] : this.serve_option.list[0]
            this.payment_mode.data = this.getOutletTrxDelivery.use ? this.payment_mode.list[0] : {}
          }
          if(this.isUsingConciergeAuth && this.$isNotEmptyV3(this.getConciergeReservation.guest_profile)){
            let gp = this.getConciergeReservation.guest_profile
            this.setTrxOutletCustomerDetail([
              { key: 'first_name',   value: gp.name  || '' },
              { key: 'email',        value: gp.email || '' },
              { key: 'phone_number', value: gp.phone || '' }
            ])
          }
          this.is_load = false
        })
      },
      loadGeneralData() {
        return new Promise((success, fail) => {
          this.general_data = {}
          get("CORE_HOTEL", `merchant-pos/${this.pos_code}/general`, {
            merchant_id: this.getMerchant.id
          }).then(response => {
            let res = response.data
            if (res.success) {
              this.general_data = res.data
              this.$validatePage('CONCIERGE',this.general_data).then(()=>{
                applyResolvedTitle({router: this.$router, title: `Order Summary - ${res.data.tagline}`, trackFn: () => {
                  trackPageViewAfterDataLoaded()
                }})

                success()
              }).catch(()=>fail())
            } else {
              fail(res.message)
            }
          })
        })
      },
      loadDetailReservation(){
				return new Promise((success,fail)=>{
          get("CONCIERGE",`reservation/${this.getReservationActive.detail_id}`,{
            merchant_id: this.getMerchant.id
          }).then(response=>{
						let res = response.data
            if(res.success){
							let resv = res.data
							if(this.$isReservationValid(resv)){
								this.reservation = resv
							} else{
								this.setReservationActive('reset')
							}
              success()
            }else{
              fail(res.message)
            }
          })
        })
			},
      goToPage(page) {
        let route = {
          name: page,
          params: {
            merchant_code: this.getMerchant.code,
            pos_code: this.pos_code
          }
        }
        this.$router.push(route)
      },
      goToHomepage(){
        this.goToPage('PosHome')
      },
      paymentModeSelect(pm){
        this.payment_mode.data = pm
        if(pm.id == 'PAY_IMMEDIATELY') {
          setTimeout(() => {
            this.$smoothScroll('PAY_LATER')
          }, 100);
        }
      },
      selectPayment(pm) {
        this.payment_method.data = pm
        setTimeout(() => {
          this.$smoothScroll('payment_guest_form')
        }, 300);
      },
      paymentMethodDoneLoad(){
        if(this.payment_mode.data.id == 'PAY_IMMEDIATELY' && !this.getOutletTrxDelivery.use) this.$smoothScroll('PAY_LATER')
      },
      clearCart(){
        this.clearTrxOutletProduct()
      },

      serveOptionSelect(serve){
        this.serve_option.selected = serve
        let use_delivery = serve.id == 'delivery'
        this.setTrxOutletDeliveryType(use_delivery)
        if(use_delivery){
          this.payment_mode.data = this.payment_mode.list[0]
          let is_map_selected = this.$isNotEmpty(this.getOutletTrxDelivery.address.latitude) && this.$isNotEmpty(this.getOutletTrxDelivery.address.longitude)
          if(!is_map_selected){
            setTimeout(() => {
              this.$refs.layout.toggleDelivery()
            }, 100);
          }
        }else{
          this.payment_mode.data = {}
        }
      },

      // SUBMIT
      getApiParams(type='inquiry'){
        let params = {}
        if(type == 'inquiry'){
          let getRoomId = () => {
            if(this.isUsingConciergeAuth) return null
            return this.isReservationActive && Object.keys(this.reservation.room).length > 0 ? this.reservation.room.id : ''
          }

          const { first_name, last_name, email, phone_number } = this.getOutletTrxCustomerDetail

          let customer_data = {
            first_name,
            last_name,
            table_number: this.getOutletTrxTableNumber,
            email,
            phone_number
          }

          params = {
            merchant_id: this.getMerchant.id,
            products:[],
            customer_detail: customer_data,
            room_id: getRoomId(),
            merchant_pos_id: this.general_data.id,
            notes: this.getOutletTrxNotes,
            region: '',
            device: this.$getDeviceType(),
            promo_code: this.getOutletTrxPromoCode,
            campaign_id: this.getUpsellRef.id != '' && this.getUpsellRef.type == 'CAMPAIGN' ? this.getUpsellRef.id : '',
            guest_journey_id: this.getUpsellRef.id != '' && this.getUpsellRef.type == 'GUEST_JOURNEY' ? this.getUpsellRef.id : '',
            cta_id: this.getUpsellRef.cta_id || '',
            reservation_id: this.getConciergeHomeAuth.reservation_id || (this.reservation.id ? this.reservation.id : null),
            payment_mode: '',
            order_type: this.general_data.use_delivery ? this.serve_option.selected.id.toUpperCase() : 'DINE_IN'
          }

          if(this.isMembershipRewardApplied){
            params.membership_reward_id = this.getMembershipRewardApplied.id
          }

          this.getOutletTrxProducts.forEach(cart=>{
            let is_variant = cart.variants.length > 0
            if(is_variant){
              cart.variants.forEach(variant=>{
                let variant_cart = {
                  id: variant.variant_data.product_ga_pos_id,
                  qty: variant.qty,
                  notes: variant.notes
                }
                params.products.push(variant_cart)
              })
            }else{
              let product_cart = {
                id: cart.product_data.product_ga_pos_id,
                qty: cart.qty,
                notes: cart.notes
              }
              params.products.push(product_cart)
            }
          })

          if(this.serve_option.selected.id == 'delivery'){
            params.payment_mode = 'PAY_IMMEDIATELY'
            params.delivery_lat = this.getOutletTrxDelivery.address.latitude
            params.delivery_long = this.getOutletTrxDelivery.address.longitude
            params.delivery_landmark = this.getOutletTrxDelivery.address.landmark
          }else{
            if(this.general_data.payment_mode != 'PAY_IMMEDIATELY_OR_LATER'){
              params.payment_mode = this.general_data.payment_mode
            }else{
              params.payment_mode = this.payment_mode.data.id
            }
          }

        }else{
          let total_amount = Number(this.tx_inquiry.total_payment)+Number(this.payment_surcharge)

          const { first_name, last_name, email, phone_number } = this.getOutletTrxCustomerDetail

          params = {
	      		merchant_id: this.getMerchant.id,
	      		tx_order_invoice_id: this.tx_inquiry.id,
	      		amount: this.$roundPriceByCurrency(Number(total_amount.toFixed(2))),
	      		customer_detail: {
	      			name: first_name,
              last_name: this.$isNotEmptyV2(last_name) ? last_name : '',
	      			email: email,
	      			phone_number: phone_number
	      		},
	      		payment_details: {
	      			id: this.payment_method.data.id,
	      			payment_method: this.payment_method.data.payment_method,
	      			bank_name: this.payment_method.data.bank_name,
	      			payment_channel: this.payment_method.data.payment_channel
	      		}
	      	}
        }
        return params
      },
      validateDelivery(){
				return new Promise((success,fail)=>{
					this.serve_option.error = ''
					if(this.general_data.use_delivery && this.general_data.payment_mode != 'PAY_LATER'){
						if(this.getOutletTrxDelivery.use){
							let is_map_selected = this.$isNotEmpty(this.getOutletTrxDelivery.address.latitude) && this.$isNotEmpty(this.getOutletTrxDelivery.address.longitude)
							if(is_map_selected){
								success()
							}else{
								this.serve_option.error = 'Please provide your delivery address'
								fail()
							}
						}else{
							success()
						}
					}else{
						success()
					}
				})
			},
			validatePayment(){
				return new Promise((success,fail)=>{
					this.payment_mode.error = false
					let p_mode = this.general_data.payment_mode
					let valid = true
					if(p_mode != 'PAY_LATER'){
						let is_payment_mode_not_selected = p_mode == 'PAY_IMMEDIATELY_OR_LATER' && !this.payment_mode.data.id
						let is_payment_method = (p_mode == 'PAY_IMMEDIATELY_OR_LATER' && this.payment_mode.data.id == 'PAY_IMMEDIATELY' ) || p_mode == 'PAY_IMMEDIATELY'

						if(is_payment_mode_not_selected){
							this.payment_mode.error = true
							valid = false
						}else if(is_payment_method){
							this.$refs.layout.validatePaymentMethod().then(()=>valid=true).catch(()=>valid=false)
						}
					}
					setTimeout(()=>{
						if(!valid){
							fail()
						}else{
							success()
						}
					},100)
				})
			},
      submitForm() {
        return new Promise((success, fail) => {
          let validateFunc = [
						this.$refs.layout.validateOrderGuestForm(),
						this.validateDelivery(),
						this.validatePayment()
					]
          Promise.all(validateFunc).then(()=>{
            this.pushApiInquiry().then(res=>{
              if(this.need_payment){
                this.tx_inquiry = res.data
                this.pushApiPayment().then(()=>{
                  success()
                }).catch(err=>{
                  this.error_push = err
                  fail()
                })
              }else{
                this.clearCart()
                this.$router.push({
                  name: 'PosPaymentResult',
                  params:{
                    merchant_code: this.getMerchant.code,
                    pos_code: this.pos_code,
                    tx_order_id : res.data.id
                  },
                  query:{
                    tx_sk: res.data.tx_sk
                  }
                })
                success()
              }
            }).catch(err=>{
              this.error_push = err
              fail()
            })
          }).catch(err => {
            const { first_name, email, phone_number } = this.getOutletTrxCustomerDetail;
            const isGuestInfoInvalid = !first_name || (!this.getOutletTrxDelivery.use && !this.getOutletTrxTableNumber) || (this.need_guest_data_for_payment && (!email || !phone_number));

            if (isGuestInfoInvalid) {
              this.$smoothScroll('add_menu_section');
            } else if (this.serve_option.error != '') {
              this.$smoothScroll('middle_section');
            }
            fail();
          });
        })
      },
      pushApiInquiry(){
        return new Promise((success,fail)=>{
          if(this.isUsingConciergeAuth && this.getConciergeHomeAuth.reservation_status){
            let invalidStatuses = ['CHECKOUT', 'CANCELLED']
            if(invalidStatuses.indexOf(this.getConciergeHomeAuth.reservation_status) !== -1){
              this.error_push = 'Your reservation has already ended'
              fail()
              return
            }
          }
          let params = this.getApiParams()
          post("CORE_HOTEL","merchant-pos/tx-inquiry",params).then(response=>{
            let res = response.data
            if(res.success){
              success(res)
            }else{
              fail(res.message)
            }
          })
        })
      },
      pushApiPayment(){
        return new Promise((success,fail)=>{
          let params = this.getApiParams('payment')
	      	post("CORE_HOTEL","merchant-pos/tx-payment",params).then(response=>{
            let res = response.data
            if(res.success){
              const { bank_name, payment_method, ch_ref1 } = this.payment_method.data;

              if(bank_name == 'XENDIT' && payment_method == 'CREDIT_CARD'){
                this.tx_payment = res.payment
                this.tx_payment.general_data = this.general_data
                this.tx_payment.tx_order_id_2 = res.tx_order_id
                this.tx_payment.tx_sk = res.tx_sk ? res.tx_sk : res.payment.tx_sk
                this.payment_in_page = true
                this.$smoothScroll('payment_section')
              }else if(bank_name == 'FLYWIRE'){
                this.$submitPaymentFlywire({
                  ...res.payment,
                  tx_order_id: res.tx_order_id,
                  tx_sk: res.tx_sk ? res.tx_sk : res.payment.tx_sk
                }, false, 'POS').finally(() => success());
              }else if(bank_name == 'RAZORPAY_CURLEC'){
                this.$submitPaymentRazorpay({
                  ...res.payment,
                  tx_order_id: res.tx_order_id,
                  tx_sk: res.tx_sk ? res.tx_sk : res.payment.tx_sk,
                  payment_config:{
                    channel: payment_method,
                    code: ch_ref1
                  }
                }, false, 'POS').finally(() => success());
              }else if(bank_name == 'STRIPE'){
                this.stripe_modal = true;
                let scriptTag = document.createElement('script');
                scriptTag.src = config.STRIPE_URL;
                document.head.appendChild(scriptTag);
                scriptTag.onload = function () {
                  const { stripe_client_secret, stripe_publishable_key } = res.payment

                  const stripe = Stripe(stripe_publishable_key);

                  initialize();

                  async function initialize() {
                    const checkout = await stripe.createEmbeddedCheckoutPage({
                      clientSecret: stripe_client_secret,
                    });

                    checkout.mount('#stripe-checkout');
                  }

                };
              }else if(bank_name == 'COMMERCEPAY'){
                this.$openLink(res.payment.commercepay_payment_url)
              }else{
                res.general_data = this.general_data
                this.$proceedPayment('CONCIERGE',this.tx_inquiry,res,this.payment_method.data,'CUSTOM_POS')
              }
              this.resetTrxOutletDelivery()
              success(res)
            }else{
              fail(res.message)
            }
          })
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/hotel/concierge/pos/Cart.vue